import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 26 22',
    defaultAriaLabel: 'Heart Icon',
};

export const HeartIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} fill="currentColor">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7188 3.33063C14.0931 1.03255 16.6998 -0.269538 19.393 0.047035C22.6841 0.433891 25.2257 3.12213 25.4276 6.42972L25.4554 6.88488C25.6335 9.80288 24.5418 12.6555 22.461 14.7089C21.1848 15.9683 19.7877 17.0989 18.2898 18.0843L13.2595 21.3937C12.9247 21.614 12.4906 21.6131 12.1567 21.3914L7.09106 18.0275C5.664 17.0799 4.32807 16.0017 3.1005 14.8069C0.931161 12.6954 -0.193741 9.73292 0.0274232 6.71374L0.0554217 6.33152C0.294294 3.07061 2.81274 0.437454 6.05979 0.0536753C8.74932 -0.264208 11.3503 1.03784 12.7188 3.33063ZM6.29455 2.03985C3.99922 2.31114 2.21893 4.17251 2.05008 6.47764L2.02208 6.85985C1.84407 9.28987 2.74946 11.6743 4.49547 13.3737C5.63426 14.4821 6.87357 15.4823 8.19743 16.3614L12.7125 19.3596L17.1906 16.4135C18.5787 15.5003 19.8735 14.4525 21.0561 13.2854C22.726 11.6375 23.6021 9.34838 23.4591 7.00674L23.4313 6.55158C23.2884 4.21018 21.4892 2.30721 19.1595 2.03336C17.1222 1.79388 15.1547 2.86294 14.2471 4.70261L13.6067 6.00072C13.4374 6.34388 13.0872 6.56035 12.7045 6.55828C12.3219 6.55622 11.974 6.33599 11.8084 5.99103L11.2092 4.74274C10.317 2.884 8.34207 1.79785 6.29455 2.03985Z"
            />
        </SvgIcon>
    );
};
